/**
 * this is the controller to handle actions and settings for the user area
 **/
export default class UserAreaController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		this.$storage = $injector.get('$sessionStorage');
		this.AppConfig = $injector.get('app.config');
	}

	/**
	 * initialize the component
	 **/
	$onInit() {
		this.user = this.$storage.auth || {};
	}
}
